import { render, staticRenderFns } from "./Privacypolicy.vue?vue&type=template&id=4ad32330&scoped=true"
import script from "./Privacypolicy.vue?vue&type=script&lang=js"
export * from "./Privacypolicy.vue?vue&type=script&lang=js"
import style0 from "./Privacypolicy.vue?vue&type=style&index=0&id=4ad32330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad32330",
  null
  
)

export default component.exports